var map = {
	"./a_analitico": 75,
	"./a_analitico.png": 75,
	"./a_estrategico": 76,
	"./a_estrategico.png": 76,
	"./account": 77,
	"./account.svg": 77,
	"./anagrama": 78,
	"./anagrama-tirant": 79,
	"./anagrama-tirant.svg": 79,
	"./anagrama.svg": 78,
	"./anagrama_tirant_blanco": 66,
	"./anagrama_tirant_blanco.png": 66,
	"./analytics/analytics_peq": 80,
	"./analytics/analytics_peq.png": 80,
	"./analytics/bghead": 81,
	"./analytics/bghead.png": 81,
	"./arg/bghead": 82,
	"./arg/bghead.png": 82,
	"./bg-circle": 83,
	"./bg-circle-front": 84,
	"./bg-circle-front.png": 84,
	"./bg-circle.png": 83,
	"./bin-card/icoAi": 67,
	"./bin-card/icoAi.png": 67,
	"./bol/bghead": 85,
	"./bol/bghead.png": 85,
	"./bra/bghead": 86,
	"./bra/bghead.png": 86,
	"./calculos_laborales_bg": 87,
	"./calculos_laborales_bg.png": 87,
	"./calculos_laborales_ico": 88,
	"./calculos_laborales_ico.png": 88,
	"./cgae/bannerheader": 89,
	"./cgae/bannerheader.png": 89,
	"./cgae/bghead": 90,
	"./cgae/bghead.png": 90,
	"./cgae/rlogo": 91,
	"./cgae/rlogo.png": 91,
	"./chl/bghead": 92,
	"./chl/bghead.png": 92,
	"./chl/favicon.ico": 532,
	"./col/bghead": 93,
	"./col/bghead.png": 93,
	"./col/favicon.ico": 533,
	"./common/anfix": 94,
	"./common/anfix.svg": 94,
	"./common/bell": 95,
	"./common/bell.svg": 95,
	"./common/calendar_leads": 96,
	"./common/calendar_leads.png": 96,
	"./common/news": 97,
	"./common/news-solid": 98,
	"./common/news-solid.svg": 98,
	"./common/news.svg": 97,
	"./common/newspaper": 99,
	"./common/newspaper.svg": 99,
	"./common/notes": 100,
	"./common/notes.svg": 100,
	"./common/save": 101,
	"./common/save.svg": 101,
	"./common/sofia": 68,
	"./common/sofia.svg": 68,
	"./common/user": 102,
	"./common/user.svg": 102,
	"./conmex/analytics": 103,
	"./conmex/analytics.png": 103,
	"./conmex/bghead": 104,
	"./conmex/bghead.png": 104,
	"./conmex/biblioteca": 105,
	"./conmex/biblioteca.png": 105,
	"./conmex/calculator": 106,
	"./conmex/calculator.png": 106,
	"./conmex/consultoria": 107,
	"./conmex/consultoria.png": 107,
	"./conmex/gacetas": 108,
	"./conmex/gacetas.png": 108,
	"./conmex/gestion": 109,
	"./conmex/gestion.png": 109,
	"./conmex/herramientas": 110,
	"./conmex/herramientas.png": 110,
	"./conmex/legislacion": 111,
	"./conmex/legislacion.png": 111,
	"./conmex/novedades": 112,
	"./conmex/novedades.png": 112,
	"./conmex/peticiones": 113,
	"./conmex/peticiones.png": 113,
	"./conmex/rfcs": 114,
	"./conmex/rfcs.png": 114,
	"./conmex/temas": 115,
	"./conmex/temas.png": 115,
	"./conversa/BannerConversa": 23,
	"./conversa/BannerConversa.png": 23,
	"./conversa/BannerConversaTolas": 24,
	"./conversa/BannerConversaTolas.png": 24,
	"./conversa/bannerConversaModal": 25,
	"./conversa/bannerConversaModal.png": 25,
	"./conversa/ico_conversa_close": 26,
	"./conversa/ico_conversa_close.png": 26,
	"./conversa/ico_conversa_float": 27,
	"./conversa/ico_conversa_float.png": 27,
	"./conversa/iconWarning": 28,
	"./conversa/iconWarning.png": 28,
	"./conversa/logoConversa": 29,
	"./conversa/logoConversa.png": 29,
	"./conversa/logoConversaIco": 30,
	"./conversa/logoConversaIco.png": 30,
	"./conversa/logo_Conversa_Color": 31,
	"./conversa/logo_Conversa_Color.png": 31,
	"./conversa/logo_Conversa_Color_Part": 32,
	"./conversa/logo_Conversa_Color_Part.png": 32,
	"./cri/bghead": 116,
	"./cri/bghead.png": 116,
	"./cri/favicon.ico": 534,
	"./dom/bghead": 117,
	"./dom/bghead.png": 117,
	"./domenj/JuritecaBeta": 118,
	"./domenj/JuritecaBeta.jpg": 118,
	"./domenj/aecid": 119,
	"./domenj/aecid.png": 119,
	"./domenj/bghead": 120,
	"./domenj/bghead.png": 120,
	"./domenj/favicon.ico": 535,
	"./domenj/home": 121,
	"./domenj/home.png": 121,
	"./domenj/home_beta": 122,
	"./domenj/home_beta.png": 122,
	"./domenj/icoFacebook": 123,
	"./domenj/icoFacebook.svg": 123,
	"./domenj/icoInstagram": 124,
	"./domenj/icoInstagram.svg": 124,
	"./domenj/icoLinked": 125,
	"./domenj/icoLinked.svg": 125,
	"./domenj/icoX": 126,
	"./domenj/icoX.svg": 126,
	"./domenj/icoYoutube": 127,
	"./domenj/icoYoutube.svg": 127,
	"./domenj/img-nosotros-contacto": 128,
	"./domenj/img-nosotros-contacto.png": 128,
	"./domenj/img-nosotros-header": 129,
	"./domenj/img-nosotros-header.png": 129,
	"./domenj/img__Form__Suggets": 130,
	"./domenj/img__Form__Suggets.png": 130,
	"./domenj/logosPJRD-ENJ": 131,
	"./domenj/logosPJRD-ENJ.png": 131,
	"./domenj/pasos_juriteca": 132,
	"./domenj/pasos_juriteca.png": 132,
	"./ecu/bghead": 133,
	"./ecu/bghead.png": 133,
	"./flags/ca": 134,
	"./flags/ca.gif": 134,
	"./flags/en": 135,
	"./flags/en.gif": 135,
	"./flags/es": 136,
	"./flags/es.gif": 136,
	"./flags/eu": 137,
	"./flags/eu.gif": 137,
	"./flags/fr": 138,
	"./flags/fr.gif": 138,
	"./flags/gl": 139,
	"./flags/gl.gif": 139,
	"./flags/pt": 140,
	"./flags/pt.gif": 140,
	"./flags/va": 141,
	"./flags/va.gif": 141,
	"./gestor_notarial_bg": 142,
	"./gestor_notarial_bg.png": 142,
	"./gestor_notarial_ico": 143,
	"./gestor_notarial_ico.png": 143,
	"./gtm/bghead": 144,
	"./gtm/bghead.png": 144,
	"./head-anagrama": 145,
	"./head-anagrama.svg": 145,
	"./hnd/bghead": 146,
	"./hnd/bghead.png": 146,
	"./icoFacebook": 147,
	"./icoFacebook.svg": 147,
	"./icoRSS": 148,
	"./icoRSS.svg": 148,
	"./icoTwitter": 149,
	"./icoTwitter.svg": 149,
	"./img_Asistente_Documental": 150,
	"./img_Asistente_Documental.jpg": 150,
	"./img_Solicitud_Formularios": 151,
	"./img_Solicitud_Formularios.jpg": 151,
	"./jam/bghead": 152,
	"./jam/bghead.png": 152,
	"./latam/bghead": 153,
	"./latam/bghead.png": 153,
	"./legal-text": 154,
	"./legal-text.svg": 154,
	"./logo_tirant_wh": 155,
	"./logo_tirant_wh.svg": 155,
	"./materias/IcoArrendamientosUrbanos": 156,
	"./materias/IcoArrendamientosUrbanos.svg": 156,
	"./materias/IcoConcursal": 157,
	"./materias/IcoConcursal.svg": 157,
	"./materias/IcoContabilidad": 158,
	"./materias/IcoContabilidad.svg": 158,
	"./materias/IcoContratos": 159,
	"./materias/IcoContratos.svg": 159,
	"./materias/IcoDefault": 160,
	"./materias/IcoDefault.svg": 160,
	"./materias/IcoEjecucionPenal": 161,
	"./materias/IcoEjecucionPenal.svg": 161,
	"./materias/IcoExtranjeria": 162,
	"./materias/IcoExtranjeria.svg": 162,
	"./materias/IcoFamilia": 163,
	"./materias/IcoFamilia.svg": 163,
	"./materias/IcoFinanciero": 164,
	"./materias/IcoFinanciero.svg": 164,
	"./materias/IcoLaboral": 165,
	"./materias/IcoLaboral.svg": 165,
	"./materias/IcoMercantil": 166,
	"./materias/IcoMercantil.svg": 166,
	"./materias/IcoPenal": 167,
	"./materias/IcoPenal.svg": 167,
	"./materias/IcoPropiedadH": 168,
	"./materias/IcoPropiedadH.svg": 168,
	"./materias/IcoUrbanismo": 169,
	"./materias/IcoUrbanismo.svg": 169,
	"./nic/bghead": 170,
	"./nic/bghead.png": 170,
	"./pan/bghead": 171,
	"./pan/bghead.png": 171,
	"./per/bghead": 172,
	"./per/bghead.png": 172,
	"./prt/bghead": 173,
	"./prt/bghead.png": 173,
	"./pry/bghead": 174,
	"./pry/bghead.png": 174,
	"./slv/bghead": 175,
	"./slv/bghead.png": 175,
	"./slv/favicon.ico": 536,
	"./sofia/sofia-color": 51,
	"./sofia/sofia-color.png": 51,
	"./sofia/sofia-color_xl": 62,
	"./sofia/sofia-color_xl.png": 62,
	"./sofia/sofia-footer": 63,
	"./sofia/sofia-footer.png": 63,
	"./sofia/sofia-info-3d": 64,
	"./sofia/sofia-info-3d.png": 64,
	"./sofia/sofia-selection": 65,
	"./sofia/sofia-selection.png": 65,
	"./sort_asc": 176,
	"./sort_asc.png": 176,
	"./sort_asc_disabled": 177,
	"./sort_asc_disabled.png": 177,
	"./sort_both": 178,
	"./sort_both.png": 178,
	"./sort_desc": 179,
	"./sort_desc.png": 179,
	"./sort_desc_disabled": 180,
	"./sort_desc_disabled.png": 180,
	"./spinner": 181,
	"./spinner.gif": 181,
	"./spinner_colors": 182,
	"./spinner_colors.svg": 182,
	"./tase/bghead": 183,
	"./tase/bghead-old": 184,
	"./tase/bghead-old.png": 184,
	"./tase/bghead.png": 183,
	"./tase/external/icos/ico-actualidad": 185,
	"./tase/external/icos/ico-actualidad.svg": 185,
	"./tase/external/icos/ico-analytics": 186,
	"./tase/external/icos/ico-analytics.svg": 186,
	"./tase/external/icos/ico-asistente": 187,
	"./tase/external/icos/ico-asistente.svg": 187,
	"./tase/external/icos/ico-ayudas": 188,
	"./tase/external/icos/ico-ayudas.svg": 188,
	"./tase/external/icos/ico-back-actualidad": 189,
	"./tase/external/icos/ico-back-actualidad.svg": 189,
	"./tase/external/icos/ico-back-analytics": 190,
	"./tase/external/icos/ico-back-analytics.svg": 190,
	"./tase/external/icos/ico-back-asistente": 191,
	"./tase/external/icos/ico-back-asistente.svg": 191,
	"./tase/external/icos/ico-back-ayudas": 192,
	"./tase/external/icos/ico-back-ayudas.svg": 192,
	"./tase/external/icos/ico-back-base-de-datos": 193,
	"./tase/external/icos/ico-back-base-de-datos.svg": 193,
	"./tase/external/icos/ico-back-biblioteca-gps": 194,
	"./tase/external/icos/ico-back-biblioteca-gps.svg": 194,
	"./tase/external/icos/ico-back-biblioteca-t-conecta": 195,
	"./tase/external/icos/ico-back-biblioteca-t-conecta.svg": 195,
	"./tase/external/icos/ico-back-biblioteca-virtual": 196,
	"./tase/external/icos/ico-back-biblioteca-virtual.svg": 196,
	"./tase/external/icos/ico-back-calculadoras": 197,
	"./tase/external/icos/ico-back-calculadoras.svg": 197,
	"./tase/external/icos/ico-back-computo": 198,
	"./tase/external/icos/ico-back-computo.svg": 198,
	"./tase/external/icos/ico-back-consultoria": 199,
	"./tase/external/icos/ico-back-consultoria.svg": 199,
	"./tase/external/icos/ico-back-convenios": 200,
	"./tase/external/icos/ico-back-convenios.svg": 200,
	"./tase/external/icos/ico-back-db-latam": 201,
	"./tase/external/icos/ico-back-db-latam.svg": 201,
	"./tase/external/icos/ico-back-diario": 202,
	"./tase/external/icos/ico-back-diario.svg": 202,
	"./tase/external/icos/ico-back-dictado": 203,
	"./tase/external/icos/ico-back-dictado.svg": 203,
	"./tase/external/icos/ico-back-gestor-despachos": 204,
	"./tase/external/icos/ico-back-gestor-despachos.svg": 204,
	"./tase/external/icos/ico-back-legislacion": 205,
	"./tase/external/icos/ico-back-legislacion.svg": 205,
	"./tase/external/icos/ico-back-solicitud": 206,
	"./tase/external/icos/ico-back-solicitud.svg": 206,
	"./tase/external/icos/ico-back-traducciones": 207,
	"./tase/external/icos/ico-back-traducciones.svg": 207,
	"./tase/external/icos/ico-base-de-datos": 208,
	"./tase/external/icos/ico-base-de-datos.svg": 208,
	"./tase/external/icos/ico-biblioteca-gps": 209,
	"./tase/external/icos/ico-biblioteca-gps.svg": 209,
	"./tase/external/icos/ico-biblioteca-t-conecta": 210,
	"./tase/external/icos/ico-biblioteca-t-conecta.svg": 210,
	"./tase/external/icos/ico-biblioteca-virtual": 211,
	"./tase/external/icos/ico-biblioteca-virtual.svg": 211,
	"./tase/external/icos/ico-btn-up": 212,
	"./tase/external/icos/ico-btn-up.svg": 212,
	"./tase/external/icos/ico-calculadoras": 213,
	"./tase/external/icos/ico-calculadoras.svg": 213,
	"./tase/external/icos/ico-computo": 214,
	"./tase/external/icos/ico-computo.svg": 214,
	"./tase/external/icos/ico-consultoria": 215,
	"./tase/external/icos/ico-consultoria.svg": 215,
	"./tase/external/icos/ico-convenios": 216,
	"./tase/external/icos/ico-convenios.svg": 216,
	"./tase/external/icos/ico-db-latam": 217,
	"./tase/external/icos/ico-db-latam.svg": 217,
	"./tase/external/icos/ico-diario": 218,
	"./tase/external/icos/ico-diario.svg": 218,
	"./tase/external/icos/ico-dictado": 219,
	"./tase/external/icos/ico-dictado.svg": 219,
	"./tase/external/icos/ico-footer-facebook": 220,
	"./tase/external/icos/ico-footer-facebook.svg": 220,
	"./tase/external/icos/ico-footer-instragram": 221,
	"./tase/external/icos/ico-footer-instragram.svg": 221,
	"./tase/external/icos/ico-footer-linkedin": 222,
	"./tase/external/icos/ico-footer-linkedin.svg": 222,
	"./tase/external/icos/ico-footer-twitter": 223,
	"./tase/external/icos/ico-footer-twitter.svg": 223,
	"./tase/external/icos/ico-footer-youtube": 224,
	"./tase/external/icos/ico-footer-youtube.svg": 224,
	"./tase/external/icos/ico-gestor-despachos": 225,
	"./tase/external/icos/ico-gestor-despachos.svg": 225,
	"./tase/external/icos/ico-legislacion": 226,
	"./tase/external/icos/ico-legislacion.svg": 226,
	"./tase/external/icos/ico-llamada": 227,
	"./tase/external/icos/ico-llamada.svg": 227,
	"./tase/external/icos/ico-solicitud": 228,
	"./tase/external/icos/ico-solicitud.svg": 228,
	"./tase/external/icos/ico-traducciones": 229,
	"./tase/external/icos/ico-traducciones.svg": 229,
	"./tase/external/icos/ico-whatsapp": 230,
	"./tase/external/icos/ico-whatsapp.svg": 230,
	"./tase/external/img/bbGPS": 231,
	"./tase/external/img/bbGPS.svg": 231,
	"./tase/external/img/bg-aro-content": 232,
	"./tase/external/img/bg-aro-content.svg": 232,
	"./tase/external/img/btn-call": 233,
	"./tase/external/img/btn-call.svg": 233,
	"./tase/external/img/btn-plus": 234,
	"./tase/external/img/btn-plus-hover": 235,
	"./tase/external/img/btn-plus-hover.svg": 235,
	"./tase/external/img/btn-plus.svg": 234,
	"./tase/external/img/btn-whatsapp": 236,
	"./tase/external/img/btn-whatsapp.svg": 236,
	"./tase/external/img/header-compu-hero": 237,
	"./tase/external/img/header-compu-hero.svg": 237,
	"./tase/external/logos/logo-bbGP": 238,
	"./tase/external/logos/logo-bbGP.svg": 238,
	"./tase/external/logos/logo-conversa": 239,
	"./tase/external/logos/logo-conversa.svg": 239,
	"./tase/external/logos/logo-footer": 240,
	"./tase/external/logos/logo-footer.svg": 240,
	"./tase/external/logos/logo-header": 241,
	"./tase/external/logos/logo-header.svg": 241,
	"./tase/external/logos/logo-sofia": 242,
	"./tase/external/logos/logo-sofia.svg": 242,
	"./tase/favicon.ico": 537,
	"./tase/icoImportant.webp": 538,
	"./tase/ico_biblioteca": 243,
	"./tase/ico_biblioteca.svg": 243,
	"./tase/ico_consultoria": 244,
	"./tase/ico_consultoria.svg": 244,
	"./timbres_honorarios_bg": 245,
	"./timbres_honorarios_bg.png": 245,
	"./timbres_honorarios_ico": 246,
	"./timbres_honorarios_ico.png": 246,
	"./tnr/bghead": 247,
	"./tnr/bghead-old": 248,
	"./tnr/bghead-old.png": 248,
	"./tnr/bghead.png": 247,
	"./tnr/ico_biblioteca": 249,
	"./tnr/ico_biblioteca.svg": 249,
	"./tnr/ico_consultoria": 250,
	"./tnr/ico_consultoria.svg": 250,
	"./tol/asistenciaporvoz": 251,
	"./tol/asistenciaporvoz.png": 251,
	"./tol/bghead": 252,
	"./tol/bghead-old": 253,
	"./tol/bghead-old.png": 253,
	"./tol/bghead.png": 252,
	"./tol/favicon.ico": 539,
	"./tol/ico_biblioteca": 254,
	"./tol/ico_biblioteca.svg": 254,
	"./tol/ico_consultoria": 255,
	"./tol/ico_consultoria.svg": 255,
	"./tolmex/bghead": 256,
	"./tolmex/bghead.png": 256,
	"./tolmex/favicon.ico": 540,
	"./tph/bghead": 257,
	"./tph/bghead-old": 258,
	"./tph/bghead-old.png": 258,
	"./tph/bghead.png": 257,
	"./tph/external/icos/btn-plus": 259,
	"./tph/external/icos/btn-plus.svg": 259,
	"./tph/external/icos/ico-actualidad": 260,
	"./tph/external/icos/ico-actualidad.svg": 260,
	"./tph/external/icos/ico-analytics": 261,
	"./tph/external/icos/ico-analytics.svg": 261,
	"./tph/external/icos/ico-asistente": 262,
	"./tph/external/icos/ico-asistente.svg": 262,
	"./tph/external/icos/ico-ayudas": 263,
	"./tph/external/icos/ico-ayudas.svg": 263,
	"./tph/external/icos/ico-back-actualidad": 264,
	"./tph/external/icos/ico-back-actualidad.svg": 264,
	"./tph/external/icos/ico-back-analytics": 265,
	"./tph/external/icos/ico-back-analytics.svg": 265,
	"./tph/external/icos/ico-back-asistente": 266,
	"./tph/external/icos/ico-back-asistente.svg": 266,
	"./tph/external/icos/ico-back-ayudas": 267,
	"./tph/external/icos/ico-back-ayudas.svg": 267,
	"./tph/external/icos/ico-back-base-de-datos": 268,
	"./tph/external/icos/ico-back-base-de-datos.svg": 268,
	"./tph/external/icos/ico-back-biblioteca-gps": 269,
	"./tph/external/icos/ico-back-biblioteca-gps.svg": 269,
	"./tph/external/icos/ico-back-biblioteca-t-conecta": 270,
	"./tph/external/icos/ico-back-biblioteca-t-conecta.svg": 270,
	"./tph/external/icos/ico-back-biblioteca-virtual": 271,
	"./tph/external/icos/ico-back-biblioteca-virtual.svg": 271,
	"./tph/external/icos/ico-back-calculadoras": 272,
	"./tph/external/icos/ico-back-calculadoras.svg": 272,
	"./tph/external/icos/ico-back-computo": 273,
	"./tph/external/icos/ico-back-computo.svg": 273,
	"./tph/external/icos/ico-back-consultoria": 274,
	"./tph/external/icos/ico-back-consultoria.svg": 274,
	"./tph/external/icos/ico-back-convenios": 275,
	"./tph/external/icos/ico-back-convenios.svg": 275,
	"./tph/external/icos/ico-back-db-latam": 276,
	"./tph/external/icos/ico-back-db-latam.svg": 276,
	"./tph/external/icos/ico-back-diario": 277,
	"./tph/external/icos/ico-back-diario.svg": 277,
	"./tph/external/icos/ico-back-dictado": 278,
	"./tph/external/icos/ico-back-dictado.svg": 278,
	"./tph/external/icos/ico-back-especialidades": 279,
	"./tph/external/icos/ico-back-especialidades.svg": 279,
	"./tph/external/icos/ico-back-gestor_despachos": 280,
	"./tph/external/icos/ico-back-gestor_despachos.svg": 280,
	"./tph/external/icos/ico-back-legislacion": 281,
	"./tph/external/icos/ico-back-legislacion.svg": 281,
	"./tph/external/icos/ico-back-solicitud": 282,
	"./tph/external/icos/ico-back-solicitud.svg": 282,
	"./tph/external/icos/ico-back-traducciones": 283,
	"./tph/external/icos/ico-back-traducciones.svg": 283,
	"./tph/external/icos/ico-base-de-datos": 284,
	"./tph/external/icos/ico-base-de-datos.svg": 284,
	"./tph/external/icos/ico-biblioteca-gps": 285,
	"./tph/external/icos/ico-biblioteca-gps.svg": 285,
	"./tph/external/icos/ico-biblioteca-t-conecta": 286,
	"./tph/external/icos/ico-biblioteca-t-conecta.svg": 286,
	"./tph/external/icos/ico-biblioteca-virtual": 287,
	"./tph/external/icos/ico-biblioteca-virtual.svg": 287,
	"./tph/external/icos/ico-btn-up": 288,
	"./tph/external/icos/ico-btn-up.svg": 288,
	"./tph/external/icos/ico-calculadoras": 289,
	"./tph/external/icos/ico-calculadoras.svg": 289,
	"./tph/external/icos/ico-computo": 290,
	"./tph/external/icos/ico-computo.svg": 290,
	"./tph/external/icos/ico-consultoria": 291,
	"./tph/external/icos/ico-consultoria.svg": 291,
	"./tph/external/icos/ico-convenios": 292,
	"./tph/external/icos/ico-convenios.svg": 292,
	"./tph/external/icos/ico-db-latam": 293,
	"./tph/external/icos/ico-db-latam.svg": 293,
	"./tph/external/icos/ico-diario": 294,
	"./tph/external/icos/ico-diario.svg": 294,
	"./tph/external/icos/ico-dictado": 295,
	"./tph/external/icos/ico-dictado.svg": 295,
	"./tph/external/icos/ico-especialidades": 296,
	"./tph/external/icos/ico-especialidades.svg": 296,
	"./tph/external/icos/ico-footer-facebook": 297,
	"./tph/external/icos/ico-footer-facebook.svg": 297,
	"./tph/external/icos/ico-footer-instragram": 298,
	"./tph/external/icos/ico-footer-instragram.svg": 298,
	"./tph/external/icos/ico-footer-linkedin": 299,
	"./tph/external/icos/ico-footer-linkedin.svg": 299,
	"./tph/external/icos/ico-footer-twitter": 300,
	"./tph/external/icos/ico-footer-twitter.svg": 300,
	"./tph/external/icos/ico-footer-youtube": 301,
	"./tph/external/icos/ico-footer-youtube.svg": 301,
	"./tph/external/icos/ico-gestor_despachos": 302,
	"./tph/external/icos/ico-gestor_despachos.svg": 302,
	"./tph/external/icos/ico-legislacion": 303,
	"./tph/external/icos/ico-legislacion.svg": 303,
	"./tph/external/icos/ico-llamada": 304,
	"./tph/external/icos/ico-llamada.svg": 304,
	"./tph/external/icos/ico-solicitud": 305,
	"./tph/external/icos/ico-solicitud.svg": 305,
	"./tph/external/icos/ico-traducciones": 306,
	"./tph/external/icos/ico-traducciones.svg": 306,
	"./tph/external/icos/ico-whatsapp": 307,
	"./tph/external/icos/ico-whatsapp.svg": 307,
	"./tph/external/img/bg-aro-content": 308,
	"./tph/external/img/bg-aro-content.svg": 308,
	"./tph/external/img/btn-call": 309,
	"./tph/external/img/btn-call.svg": 309,
	"./tph/external/img/btn-plus": 310,
	"./tph/external/img/btn-plus.svg": 310,
	"./tph/external/img/btn-whatsapp": 311,
	"./tph/external/img/btn-whatsapp.svg": 311,
	"./tph/external/img/header-compu-hero": 52,
	"./tph/external/img/header-compu-hero.png": 52,
	"./tph/external/img/header-compu-hero.svg": 541,
	"./tph/external/logos/logo-conversa": 312,
	"./tph/external/logos/logo-conversa.svg": 312,
	"./tph/external/logos/logo-footer": 313,
	"./tph/external/logos/logo-footer.svg": 313,
	"./tph/external/logos/logo-header": 314,
	"./tph/external/logos/logo-header.svg": 314,
	"./tph/external/logos/logo-sofia": 315,
	"./tph/external/logos/logo-sofia.svg": 315,
	"./tph/favicon.ico": 542,
	"./tph/icoImportant": 316,
	"./tph/icoImportant.svg": 316,
	"./tph/icoImportant.webp": 543,
	"./tph/ico_biblioteca": 317,
	"./tph/ico_biblioteca.svg": 317,
	"./tph/ico_consultoria": 318,
	"./tph/ico_consultoria.svg": 318,
	"./tto/bghead": 319,
	"./tto/bghead.png": 319,
	"./ury/bghead": 320,
	"./ury/bghead.png": 320,
	"./ven/bghead": 321,
	"./ven/bghead.png": 321
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 531;